export default __webpack_public_path__ + "c5b9446a65b56bd0b8c09e4cecf160e9.png";